/* H2O click-attribution capture: private cart attributes only. */
(function () {
  'use strict';
  var keys = ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign'];
  var storageKey = 'h2o_attribution_v1';
  var sentKey = 'h2o_attribution_sent_v1';
  function clean(value, max) {
    return String(value || '').trim().slice(0, max);
  }
  function load() {
    try { return JSON.parse(sessionStorage.getItem(storageKey) || '{}'); }
    catch (_) { return {}; }
  }
  function save(data) {
    try { sessionStorage.setItem(storageKey, JSON.stringify(data)); }
    catch (_) {}
  }
  function collect() {
    var params = new URLSearchParams(window.location.search);
    var current = load();
    var found = false;
    keys.forEach(function (key) {
      var value = clean(params.get(key), key === 'utm_campaign' ? 512 : 255);
      if (value) { current[key] = value; found = true; }
    });
    if (found) {
      current.landing_page = clean(window.location.pathname, 1024);
      current.captured_at = new Date().toISOString();
      save(current);
    }
    return current;
  }
  function persist() {
    var data = collect();
    if (!data.gclid && !data.gbraid && !data.wbraid && !data.utm_source) return;
    var attributes = {};
    if (data.gclid) attributes.__h2o_gclid = data.gclid;
    if (data.gbraid) attributes.__h2o_gbraid = data.gbraid;
    if (data.wbraid) attributes.__h2o_wbraid = data.wbraid;
    if (data.utm_source) attributes.__h2o_utm_source = data.utm_source;
    if (data.utm_medium) attributes.__h2o_utm_medium = data.utm_medium;
    if (data.utm_campaign) attributes.__h2o_utm_campaign = data.utm_campaign;
    if (data.landing_page) attributes.__h2o_landing_page = data.landing_page;
    if (data.captured_at) attributes.__h2o_attribution_captured_at = data.captured_at;
    // Shopify can acknowledge an attribute update before a cart has line items.
    // Retrying on later pages and immediately after add-to-cart attaches the same
    // private attribution fields to the order-bearing cart without exposing values.
    fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({attributes: attributes})
    }).catch(function () {});
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && /\/cart\/add(?:\.js)?(?:$|\?)/.test(form.action || '')) {
      window.setTimeout(persist, 800);
    }
  }, true);
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest && event.target.closest('button[name="add"], [data-add-to-cart]');
    if (target) window.setTimeout(persist, 800);
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', persist, {once: true});
  else persist();
}());
